var map = {
	"./activity.js": "146a",
	"./count.js": "c5cf",
	"./directory.js": "148e",
	"./duration.js": "c7d6",
	"./games.js": "a5fe",
	"./groups.js": "2589",
	"./hindex.js": "61cc",
	"./index.js": "e3f2",
	"./init.js": "67ab",
	"./mostgames.js": "31f0",
	"./mostplays.js": "686d",
	"./newcomers.js": "55ce",
	"./overview.js": "d5a4",
	"./plays.js": "700b",
	"./specialised.js": "0630",
	"./streaks.js": "b137",
	"./weight.js": "69ac",
	"./wins.js": "65df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b2a";